import con from "../../../connection";
var path = '/version';
var version = function (url) { return function (versionNumber) { return ({
    get: function () { return con.get(url + path + "/" + versionNumber, {}); }
}); }; };
export default version;
